import moment from 'moment';
import momentTimezone from 'moment-timezone';
import { SET_USER_INFORMATION, USER_ROLES_ID as UserRoles } from '../utils/constant.utils';
import { MATRIX_INDICATOR as matrix } from '../utils/rbac-constants.utils';
import isEqual from 'lodash/isEqual';

export function getRequestUserSessionData() {
    return {
        userId: sessionStorage.UserID
        , employeeID: sessionStorage.EmployeeID
        , firstName: sessionStorage.FirstName
        , lastName: sessionStorage.LastName
        , middleInitial: sessionStorage.MiddleInitial
        , vip: sessionStorage.Vip
        , enterpriseId: sessionStorage.EID
        , managerApproverId: sessionStorage.ManagerApproverID
        , requestInBehalfId: null
    };
}

export function showApprovalNotif() {
    const roleId = parseInt(sessionStorage.getItem('UserRoleID'));

    return roleId === UserRoles.manager || roleId === UserRoles.lineManager || JSON.parse(sessionStorage.getItem('IsWireLineApprover')) || JSON.parse(sessionStorage.getItem('IsCostCodeAuthorizer'))
}

export function trueFalseToBoolean(value) {
    if (typeof value == "boolean") {
        return value;
    }
    if (value != null && value !== undefined && value.toLowerCase() === 'true') return true;
    return false;
}

export function convertStringBoolToBoolean(value) {
    if (typeof value == "boolean") {
        return value;
    }
    if (value != null && value !== undefined && (value.toLowerCase() === 'true' || value.toLowerCase() === '1')) return true;
    return false;
}
export function removeLastSubPath(url, num) {
    var i;
    for (i = 0; i < num; i++) {
        url = url.substring(0, url.lastIndexOf('/') + 0);
    }
    return url;
}

export function getLocalTimeZone() {
    var date = new Date();
    return date.getTimezoneOffset();
}

export function convertToDate(dateString, format) {
    //var toLocalDate = config.IsEnabledMultiTimeZone ? moment.utc(dateString).toDate().toString() : dateString;
    var toLocalDate = true ? moment.utc(dateString).toDate().toString() : dateString;
    return moment(toLocalDate).format(format);
}

export function convertToUtcDate(dateString, convertOnlyDate, targetFormat, addDayValue) {
    var zone = moment.tz.guess();
    dateString = convertOnlyDate ? moment(dateString).startOf('day') : dateString;
    return momentTimezone.tz(dateString, zone).utc().add(addDayValue, 'days').format(targetFormat);
}

export function convertUtcToLocalDate(utcTime) {
    var localDate = moment.utc(utcTime).local();
    return localDate;
}

export function convertToFormatLocalDate(date, dateFormat) {
    if(date === "" || date === null || date === undefined) return date
    var localDate = moment.utc(date).local();
    return localDate.format(dateFormat);
}

export function convertToFormatDate(date, dateFormat) {
    return moment(date).format(dateFormat);
}

export function convertToLocalDateToUTCDate(date, toUTC, format) {
    date = new Date(date);

    var localOffset = date.getTimezoneOffset() * 60000;
    var localTime = date.getTime();
    if (toUTC) {
        date = localTime + localOffset;
    } else {
        date = localTime - localOffset;
    }
    date = new Date(date);
    return format ? moment(date).format(format) : date;
}

export function convertFormattedDateToDate(dateString, dateFormat) {
    return moment(dateString, dateFormat);
}

export function toYesOrNo(val) {
    if (val) return 'Yes';
    return 'No';
}

export function removePlusSign(val) {
    if (val === '' && val === null) return;

    val = val.trim();
    if (val.charAt(0) === '+') {
        val = val.substr(1);
    }

    return val;
}

export function loadUserSessionStorage() {
    try {
        const serializedState = sessionStorage.getItem('User');

        if (serializedState === null) {
            return undefined;
        }

        return JSON.parse(serializedState);
    } catch (error) {
        return undefined;
    }
}


export function findObjVal(data, value) {
    return data?.find(obj => value?.includes(obj?.name))
}

export function valueExist(obj, value) {
    return Object.values(obj).includes(value);
}

export function removeDomainName (target){
    return target.substring(0, target.indexOf("@"));
}

export function setUserTestHarness(payload) {
    return {
        type: SET_USER_INFORMATION,
        payload: payload
    };
}

export function objectToListKey(objects) {
    let newList = [];
    objects.forEach(function (obj) {
        newList.push(obj.Key);
    })
    return newList;
}

export function newListSomeValue(v, list) {
    let newList = [...list];
    if (list.some((value) => value === v)) {
        newList = newList.filter((val) => val !== v);
    } else {
        newList.push(v);
    }
    return newList
}
export function isValid(data) {
    return ([undefined, null, '', 0].indexOf(data) === -1);
}
export function hasProperty(obj, prop) {
    if (!isValid(obj)) return false;
    return obj.hasOwnProperty(prop);
}
export const areObjectsEqual = (obj1, obj2) => {
    try {
        return JSON.stringify(obj1) === JSON.stringify(obj2);
    } catch (e) {
        return undefined;
    }
}

export function isInteger(value) {
    return !isNaN(value) &&
        parseInt(Number(value)) == value &&
        !isNaN(parseInt(value, 10));
}

export function capitalizeFirstLetter(string, isAllLowerCase = true) {
    const newString = isAllLowerCase ? string.toLowerCase() : string.toUpperCase();

    return newString.charAt(0).toUpperCase() + newString.slice(1);
}

export function isIsoDate(date) {
    return moment(date, moment.ISO_8601, true).isValid();
}

export function isValidFormattedDate(dateString) {
    if (typeof dateString !== 'string')
        return false;

    var dateFormatOptions = JSON.parse(sessionStorage.getItem('AdminSetting')).DateFormatOptions;

    if (dateFormatOptions.length > 0) {
        dateFormatOptions = dateFormatOptions.map(item => item.Value);
    }

    return moment(dateString, dateFormatOptions, true).isValid();
}

export function getFirstNameFromFullName(fullName){
    var firstName = "";
    if(fullName) {
        const nameList = fullName.split(",")[1].split(" ");
        var index = 0;
        while(nameList && index < nameList.length - 1) {
            firstName = firstName + " " + nameList[index++];
        }
    }
    return firstName;
}

export function validateAccessModule(identifier, matrixIds) {
    var obj = JSON.parse(sessionStorage.getItem("AccessModuleMatrix"));
    var result = true;

    for (var i = 0; i < obj.length; i++) {
        if (identifier == matrix.MatrixId && matrixIds.includes(obj[i].MatrixId)) {
            return false;
        } else if (identifier == matrix.ModuleId && matrixIds.includes(obj[i].ModuleId)) {
            return false;
        } else if (identifier == matrix.FeatureId && matrixIds.includes(obj[i].FeatureId)) {
            return false;
        } else if (identifier == matrix.CategoryId && matrixIds.includes(obj[i].CategoryId)) {
            return false;
        } else if (identifier == matrix.LoginTypeId && matrixIds.includes(obj[i].LoginTypeId)) {
            return false;
        }
    }

    return result;
}

export function compareIgnoreCase(a, b) {
    const valueA = a.toUpperCase();
    const valueB = b.toUpperCase();

    if (valueA < valueB) {
        return -1;
    }
    if (valueA > valueB) {
        return 1;
    }

    return 0;
}

export function tryGetNodeAlt(obj, altVal, node) {
    try {
        if (!isValid(obj)) return altVal;
        const nodes = node.split('.');
        return nodes.reduce((o, n) => o && o[n], obj) || altVal;
    } catch (e) {
        return altVal;
    }
}

export function assignDefaultIfEmptyString(prop, defaultValue){
    return prop === '' || prop === 0 || prop === null || prop === undefined? defaultValue : prop;
}

export function hasObjectWithProperty(array, propName, value){
    return array.some(obj => obj[propName] === value)
}

export function normalizeData(data) {
    const normalizeValues = (obj) => {
      const sortedObj = {};
      Object.keys(obj).sort().forEach(key => {
        if (obj[key] === null || obj[key] === undefined) {
          sortedObj[key] = "";
        } else if (typeof obj[key] === 'object' && !Array.isArray(obj[key]) && obj[key] !== null) {
          sortedObj[key] = normalizeValues(obj[key]);
        } else if (typeof obj[key] !== 'object') {
          sortedObj[key] = String(obj[key]);
        } else if (Array.isArray(obj[key])) {
          sortedObj[key] = obj[key].map(innerObj => normalizeValues(innerObj));
        }
      });
      return sortedObj;
    };

    const normalizedData = JSON.parse(JSON.stringify(data));
    return normalizeValues(normalizedData);
  };

  export function areIdsEqual(originalIds, updatedIds) {
    const normalizedOriginalIds = originalIds.map(item => item.ID);
    const normalizedUpdatedIds = updatedIds.map(item => item.ID);
    return isEqual(normalizedOriginalIds, normalizedUpdatedIds);
}

export function areDataEqual(originalData, updatedData) {
    return isEqual(originalData, updatedData);
}

export function isObjectEqual(object1, object2) {
    try {
        const isObject = (object) => {
            return object != null && typeof object === "object";
        };

        const objKeys1 = Object.keys(object1);
        const objKeys2 = Object.keys(object2);

        if (objKeys1.length !== objKeys2.length) return false;

        for (var key of objKeys1) {
            const value1 = object1[key] ? object1[key] : "";
            const value2 = object2[key] ? object2[key] : "";

            if (value1 instanceof Date && value2 instanceof Date) {
                var date1 = `${value1.getDate()}-${value1.getDay()}-${value1.getFullYear()}`;
                var date2 = `${value2.getDate()}-${value2.getDay()}-${value2.getFullYear()}`;

                if (date1 !== date2) {
                    return false;
                }
            }

            const isObjects = isObject(value1) && isObject(value2);

            if ((isObjects && !isObjectEqual(value1, value2)) ||
                (!isObjects && value1 != value2)
            ) {
                return false;
            }
        }
        return true;
    }
    catch {
        return false;
    }
};

export function isDecimal(value){
    if (isNaN(Number(value))) return 0 ;

    // Check if the value is a string before calling indexOf
    if (typeof value === 'string') {
        return value.indexOf(".");
    }

    return -1;
}

export function displayFinalFileName(data){
    const filename = data;
    const extIndex = filename.lastIndexOf('.');
    const newName = filename.substring(0, Math.min(extIndex, 20));
    const extension = filename.substring(extIndex + 1);
    const finalName = extIndex > 20 ? `${newName}...${extension}` : filename;
    return finalName;
}

export function convertToPagedList(data, pageIndex, pageSize, indexFrom = 0) {
    if (data != null && data?.length > 0) {
        var data = {
            PageIndex: pageIndex,
            PageSize: pageSize,
            IndexFrom: indexFrom,
            TotalCount: data.length,
            TotalPages: Math.ceil(data.length / pageSize),
            Items: data.slice((pageIndex - indexFrom) * pageSize, pageSize)
        };

        return {
            ...data,
            HasNextPage: pageIndex - indexFrom + 1 < data.TotalPages,
            HasPreviousPage: pageIndex - indexFrom > 0
        };
    }
    else {
        var data = {
            PageIndex: pageIndex,
            PageSize: pageSize,
            IndexFrom: indexFrom,
            TotalCount: 0,
            TotalPages: 0,
            Items: [],
            HasNextPage: false,
            HasPreviousPage: false
        };

        return data;
    }
}

export function headerColumnProps(propName, name) {
    return {
        columnCharCss: "",
        hidden: false,
        isDateTime: false,
        isLink: false,
        isSorted: false,
        isSortedAsc: false,
        name: name,
        order: 0,
        propName: propName,
        searchString: "",
        shortName: ""
    }
}

export function modifyResponse(data, params) {

    const statusMap = new Map(params.map(item => [item.Key.toString(), item.Value]));

    const modifiedItems = data['Data'].Items.map(item => {
        if (item.Object === "Invoice Status ID") {
            item.OldValue = statusMap.get(item.OldValue) || item.OldValue;
            item.NewValue = statusMap.get(item.NewValue) || item.NewValue;
            item.Object = 'Status';
        }        
         return item;
    });

    return { ...data, Data: { ...data.Data, Items: modifiedItems } };
}

export function formatBytes(bytes, decimals = 2) {
    if (!+bytes) return '0 Bytes'

    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

    const i = Math.floor(Math.log(bytes) / Math.log(k))

    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
}

export function convertToDecimal(value) {
    if(typeof value === "string") return value;

    const result = (Math.round(value * 100) / 100).toFixed(2);

    return result;
}